export function rgbToHex(r, g, b) {
  r = Math.min(255, Math.max(0, r))
  g = Math.min(255, Math.max(0, g))
  b = Math.min(255, Math.max(0, b))

  const hexR = r.toString(16).padStart(2, '0')
  const hexG = g.toString(16).padStart(2, '0')
  const hexB = b.toString(16).padStart(2, '0')
  return `#${hexR}${hexG}${hexB}`
}

export function rgbaToHex(r, g, b, a) {
  r = Math.min(255, Math.max(0, r))
  g = Math.min(255, Math.max(0, g))
  b = Math.min(255, Math.max(0, b))

  a = Math.min(1, Math.max(0, a))

  const alpha = Math.round(a * 255)

  const hexR = r.toString(16).padStart(2, '0')
  const hexG = g.toString(16).padStart(2, '0')
  const hexB = b.toString(16).padStart(2, '0')
  const hexA = alpha.toString(16).padStart(2, '0')

  return `#${hexR}${hexG}${hexB}${hexA}`
}

export function hexToRgbString(hex) {
  const hexValue = hex.replace(/^#/, '')
  const bigint = parseInt(hexValue, 16)
  const r = (bigint >> 16) & 255
  const g = (bigint >> 8) & 255
  const b = bigint & 255

  return `rgb(${r}, ${g}, ${b})`
}

export function rgbStringToHex(rgbString) {
  const match = rgbString.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/)

  if (match) {
    const r = parseInt(match[1], 10)
    const g = parseInt(match[2], 10)
    const b = parseInt(match[3], 10)

    const hexColor = rgbToHex(r, g, b)

    return hexColor
  } else {
    return null
  }
}

export function rgbaStringToHex(rgbaString) {
  const match = rgbaString.match(/rgba\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/i)

  if (match) {
    const r = parseInt(match[1], 10)
    const g = parseInt(match[2], 10)
    const b = parseInt(match[3], 10)
    const a = parseFloat(match[4])

    const hexColor = rgbaToHex(r, g, b, a)

    return hexColor
  } else {
    return null
  }
}

export function extractRGB(rgbString, opacity) {
  const match = rgbString.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/)

  if (match) {
    const r = parseInt(match[1], 10)
    const g = parseInt(match[2], 10)
    const b = parseInt(match[3], 10)

    const a = opacity / 100
    const rgba = `rgba(${r},${g},${b},${a})`

    const rgb = `rgb(${r},${g},${b})`

    return { r, g, b, rgba, rgb }
  } else {
    return null
  }
}

export function formatRGB(rgbString, opacity) {
  let rgbValues = extractRGB(rgbString)
  let hexValue = rgbStringToHex(rgbString)
  let hexFValue = hexWithOpacity(hexValue, opacity)
  return { ...rgbValues, hex: hexValue, rgb: rgbString, opacity: opacity, hexF: hexFValue }
}

export function parseRGB(rgbString) {
  const match = rgbString.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/)

  if (match) {
    return [parseInt(match[1], 10), parseInt(match[2], 10), parseInt(match[3], 10)]
  }
  return null
}

export function hexWithOpacity(hex, opacity) {
  let alpha = Math.round((opacity / 100) * 255)
    .toString(16)
    .padStart(2, '0')

  return `${hex}${alpha}`
}

export function isValidRgbString(rgbString) {
  const regex = /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/
  const match = rgbString.match(regex)

  if (match) {
    const red = parseInt(match[1], 10)
    const green = parseInt(match[2], 10)
    const blue = parseInt(match[3], 10)

    if (red >= 0 && red <= 255 && green >= 0 && green <= 255 && blue >= 0 && blue <= 255) {
      return true
    }
  }
  return false
}

export function isValidRgbaString(rgbaString) {
  const regex = /^rgba\(\s*(\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*((0|1)(\.\d{1,2})?)\s*\)$/
  const match = rgbaString.match(regex)

  if (match) {
    const red = parseInt(match[1], 10)
    const green = parseInt(match[2], 10)
    const blue = parseInt(match[3], 10)
    const alpha = parseFloat(match[4])

    if (red >= 0 && red <= 255 && green >= 0 && green <= 255 && blue >= 0 && blue <= 255 && alpha >= 0 && alpha <= 1) {
      return true
    }
  }
  return false
}

export function isValidHexString(hexString) {
  const regex = /^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/
  return regex.test(hexString)
}

export function isValidHexFString(hexString) {
  const regex = /^#?([a-fA-F0-9]{8}|[a-fA-F0-9]{4})$/
  return regex.test(hexString)
}

export function isValidOpacityValue(opacity) {
  return opacity >= 0 && opacity <= 100
}

export function getHexfOpacity(hexString) {
  const opacityHexString = hexString.slice(7, 9)
  if (opacityHexString === '') return 100
  const opacityHex = parseInt(opacityHexString, 16)
  const opacityPercentage = (opacityHex * 100) / 255

  return Math.round(opacityPercentage)
}

export function convertColorStringToHex(colorString) {
  if (isValidHexString(colorString) || isValidHexFString(colorString)) return colorString
  if (isValidRgbString(colorString)) return rgbStringToHex(colorString)
  if (isValidRgbaString(colorString)) return rgbaStringToHex(colorString)
  return null
}
